module.exports = __webpack_public_path__ + "static/media/24WingChunAcademyLR-158.1a6d61f2.jpg";